import React from 'react';

const DataList = ({ value = [] }) => (
  <ul>
    {value.map((item, index) => (
      <li key={index}>{item}</li> // eslint-disable-line react/no-array-index-key
    ))}
  </ul>
);

export default DataList;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/DataList/index.js